import React, {
  InputHTMLAttributes,
  forwardRef,
  memo,
} from 'react';

const Checkbox = memo(
  forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
    (
      { className, children, ...props },
      ref
    ) => {
      return (
        <label className={className}>
          <input {...props} ref={ref} />
          {children}
        </label>
      );
    }
  )
);

export default Checkbox;
